import BpmnPropertiesProvider from './BpmnPropertiesProvider';

export default {
  __init__: [ 'bpmnPropertiesProvider' ],
  bpmnPropertiesProvider: [ 'type', BpmnPropertiesProvider ]
};